var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchboxSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Q2",
    "data-name": "icons Q2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.107,
    height: 19.959,
    viewBox: "0 0 20.107 19.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54408",
    "data-name": "Path 54408",
    d: "M17.16,15.96a7.375,7.375,0,0,0,1.492-5.427,7.562,7.562,0,0,0-6.861-6.572A7.48,7.48,0,0,0,10.3,18.847,7.6,7.6,0,0,0,15.768,17.4l6.215,6.173a.944.944,0,0,0,1.392,0h0a.947.947,0,0,0,0-1.394Zm-5.022.9a5.473,5.473,0,0,1-6.265-6.372,5.475,5.475,0,0,1,9.242-2.932,5.431,5.431,0,0,1,1.5,4.824,5.522,5.522,0,0,1-4.475,4.481Z",
    transform: "translate(-3.574 -3.924)",
    fill: "#6d6c6c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchboxSearchIcon);
export default __webpack_public_path__ + "static/media/searchbox-search-icon.2e3f3420b1cd44102ff3b2f15486751a.svg";
export { ForwardRef as ReactComponent };